import {Action, action, Thunk, thunk} from 'easy-peasy';
import sleep from '@/utils/sleep';


export interface StoryboardGridAnimationModel {
    inAnimation: boolean;
    startAnimation: Action<StoryboardGridAnimationModel>;
    stopAnimation: Action<StoryboardGridAnimationModel>;
    setInGridAnimation: Thunk<StoryboardGridAnimationModel>;
}

export default <StoryboardGridAnimationModel>{
    inAnimation: false,
    startAnimation: action((state) => {
        // Grid animation is NOT handled by this, but the animate-css-grid package called in Storyboard.js.
        // This disables the user interface for the duration of the animation for a smoother animation.
        state.inAnimation = true;
    }),
    stopAnimation: action((state) => {
        // This needn't be called from anywhere but onGridAnimation
        state.inAnimation = false;
    }),
    setInGridAnimation: thunk(async (actions) => {
        actions.startAnimation();

        await sleep(400);

        actions.stopAnimation();
    }),
};
